import { RadioButtonOption } from "../../../common/enums";

export const HYDROGEN_SULPHIDE_CHECKLIST_VERSION_2026_02 = 1;

export type HydrogenSulphideChecklist = {
    checklistVersion: number | undefined;
    isEscapeMasksAvailable: RadioButtonOption;
    isPortalHydroGenSulphideAlarmAvailable: RadioButtonOption;
    isWindDirectionThoughtOf: RadioButtonOption;
    isContinousGasMeasurementsInPlace: RadioButtonOption;
    isContinuousVentilationInPlace: RadioButtonOption;
    isFreshAirMaskNeededDuringWork: RadioButtonOption;
    isContinuousVentilationNeeded: RadioButtonOption;
    isEscapeMasksAvailableForAllInvolved: RadioButtonOption;
    isHydrogenSulphideGasMeterAvailable: RadioButtonOption;
    isContinousGasMeasurementsInPlaceForEntirityOfWork: RadioButtonOption;
    isWindDirectionConsideredDuringWork: RadioButtonOption;
};

